import { useState } from 'react';

export const useToggleModal = (initialValue = false) => {
  const [isModalOpen, setIsModalOpen] = useState(initialValue);

  const handleModalOpen = () => setIsModalOpen(true);
  const handleModalClose = () => setIsModalOpen(false);

  return {
    isModalOpen,
    handleModalOpen,
    handleModalClose,
  };
};
